export function formatDate(
  date: Date,
  options: {
    separator?: string;
  } = {},
) {
  const { separator = "|" } = options;
  if (!date || date.toString() === "Invalid Date") return "";
  const adjustedDate = new Date(
    date.toLocaleString("en-US", { timeZone: "Asia/Jerusalem" }),
  );

  // Formatting the adjusted date
  const formattedDate = new Intl.DateTimeFormat("he-IL", {
    day: "numeric",
    month: "numeric",
    hour: "numeric",
    minute: "numeric",
  }).format(adjustedDate);

  return String(formattedDate.split(",").join(` ${separator.trim()} `));
}
